export default __webpack_public_path__ + "static/media/doctor-patient-circled.3f3be5f6.svg";